import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dreamparse, DreamparseOptions } from './dreamparse.service';

export { Dreamparse };
export { DreamparseOptions };

export interface DreamparseConfig {
 serverURL: string;
 appId: string;
 masterKey?: string;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class DreamparseModule {
  static forRoot(config: DreamparseOptions): ModuleWithProviders {
    return {
      ngModule: DreamparseModule,
      providers: [
        {
          provide: FOR_ROOT_OPTIONS_TOKEN,
          useValue: config
        },
        {
          provide: Dreamparse,
          useFactory: provideMyServiceOptions,
          deps: [FOR_ROOT_OPTIONS_TOKEN]
        }
      ]
    }
  }
}

export var FOR_ROOT_OPTIONS_TOKEN = new InjectionToken<DreamparseConfig>("forRoot() DreamParse configuration.");

export function provideMyServiceOptions(config?: DreamparseConfig): Dreamparse {
  return new Dreamparse(config);
}